<div class="d-flex navigation-header">
  <h1 (click)="goBack()" id="admin">{{"admin.title" | translate }}</h1>
  <h1>&nbsp;> {{"admin.settings" | translate}}</h1>
</div>

<div class="block">
  <h1>{{"admin.defaultSettings.title" | translate}}</h1>
  <div>
    <div class="d-flex">
      <div class="options">
        <h2>{{"admin.defaultSettings.emailAddressTitle" | translate}}</h2>
        <h3>{{"admin.defaultSettings.emailAddressDescription" | translate}}</h3>
      </div>
      <div class="d-flex">
        <mat-form-field color="standart">
          <mat-label>Email</mat-label>
          <input matInput [(ngModel)]="email">
        </mat-form-field>
        <button mat-flat-button color="primary" class="update-button" (click)="changeEmail(email)">
          {{'admin.changeEmail'| translate}}
        </button>
      </div>
    </div>
    <div class="d-flex">
      <div class="options">
        <h2>{{"admin.orderNotification" | translate}}</h2>
      </div>
      <div style="margin-top: 9px">
        <mat-checkbox [(ngModel)]="inform" (click)="switchInform()"></mat-checkbox>
      </div>
    </div>
  </div>
</div>

<div class="block">
  <h1>{{"admin.hechtProposal.title" | translate}}</h1>
  <div>
    <div class="d-flex">
      <div class="options">
        <h2>{{"admin.hechtProposal.hsaTitle" | translate}}</h2>
        <h3>{{"admin.hechtProposal.hsaDescription" | translate}}</h3>
      </div>
      <div class="d-flex">
        <mat-form-field class="numeric-input" color="standart">
          <input matInput [(ngModel)]="hsa">
        </mat-form-field>
        <div class="info">
          <img src="assets/img/icons/info.svg"
               [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(5,35)"
               matTooltipPosition="above"/>
        </div>
        <button mat-flat-button color="primary" (click)="changeHsa(hsa)" class="update-button">
          {{'admin.changeHsa' | translate}}
        </button>
      </div>
    </div>
    <div *ngIf="!isHsaValid" class="validation-error" style="color: red;">
      {{'common.validation.numeric' | translate:getFieldFormatted("admin.accounts.hsa" | translate)}}
    </div>
    <div *ngIf="!isHsaValid" class="validation-error" style="color: red;">
      {{'newOrder.finalLens.limits' | translate:getLimitsFormatted(5,35)}}
    </div>

    <div class="d-flex">
      <div class="options">
        <h2>{{"admin.hechtProposal.measuringAngleTitle" | translate}}</h2>
        <h3>{{"admin.hechtProposal.measuringAngleDescription" | translate}}</h3>
      </div>
      <div class="d-flex">
        <mat-form-field class="numeric-input" color="standart">
          <input matInput [(ngModel)]="degree">
        </mat-form-field>
        <div class="info">
          <img src="assets/img/icons/info.svg"
               [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(15,35)"
               matTooltipPosition="above"/>
        </div>
        <button mat-flat-button color="primary" (click)="changeDegree(degree)" class="update-button">
          {{'admin.changeDegree' | translate}}
        </button>
      </div>
    </div>
    <div *ngIf="!isDegreeValid" class="validation-error" style="color: red;">
      {{'common.validation.numeric' | translate:getFieldFormatted("admin.accounts.degree" | translate)}}
    </div>
    <div *ngIf="!isDegreeValid" class="validation-error" style="color: red;">
      {{'newOrder.finalLens.limits' | translate:getLimitsFormatted(15,35)}}
    </div>

    <div class="d-flex">
      <div class="options">
        <h2>{{"admin.hechtProposal.desiredGeometryTitle" | translate}}</h2>
      </div>
      <div class="d-flex">
        <mat-radio-group [(ngModel)]="configuration" (change)="switchConfiguration()">
          <mat-radio-button [value]="bias" class="mat-radio-button-first">{{bias}}</mat-radio-button>
          <mat-radio-button [value]="ascon">{{ascon}}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
</div>

<div class="block">
  <h1>{{"admin.finalContactLens.title" | translate}}</h1>
  <div>
    <div class="d-flex">
      <div class="options">
        <h2>{{"admin.finalContactLens.returnTitle" | translate}}</h2>
        <h3>{{"admin.finalContactLens.returnDescription" | translate}}</h3>
      </div>
      <div class="d-flex">
        <mat-radio-group [(ngModel)]="isReturn" (click)="switchReturn()">
          <mat-radio-button [value]="true" class="mat-radio-button-first">
            {{"admin.finalContactLens.withReturn" | translate}}
          </mat-radio-button>
          <mat-radio-button [value]="false">{{"admin.finalContactLens.withoutReturn" | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
</div>
